import React from 'react';

import { Redirect } from '../components/Router';

const TeamNoIdRedirect = () => <Redirect to="/search" />;

export default TeamNoIdRedirect;
